import { t } from "i18next";
import { Home } from "neetoicons";

export const DEFAULT_HOME_BUTTON_PROPS = {
  tooltip: {
    content: t("neetoMolecules.navigationHeader.home"),
    position: "bottom",
  },
  homeUrl: "/",
  icon: <Home />,
};
